<template>
  <div>
    <div class="header">
      <link rel="stylesheet" type="text/css" href="../assets/css/cg_style.css"/>
      <link rel="stylesheet" type="text/css" href="../assets/css/chongzhi.css"/>
      <link rel="stylesheet" type="text/css" href="../assets/css/hxq_qyrz.css"/>
      <div class="w1200 clearfix" style="margin: 0 auto;width:1200px;">
          <div class="header_l">
              欢迎光临志鹏供应链&emsp;<em><img src="../../assets/images/zp_01.png"> 400-040-7890</em>
          </div>
          <div class="header_r">
            <router-link :to="{path:'/TaskAllocation'}" class="wddd_msgbtn">
              <span class="nav-icon-badge" v-if="MassageCount">{{MassageCount}}</span>
            </router-link>
            <router-link class="service_btn" :to="{path:'/Service'}" title="在线客服" target="_blank"><i class="el-icon-service"></i> 在线客服</router-link>
            <a href="javascript:;" class="ewm_btn">手机版<em><img src="../../assets/images/qr000.png" alt=""></em></a>
            <template v-if="current_user.id">
              <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
            </template>
            <template v-if="current_user.id">
              <a href="javascript:;" class="login_btn" @click="logout">退出</a>
              <router-link :to="{path:'/MyOrder'}" style="color:#76a9f6;">欢迎-{{current_user.name || current_user.tel}}</router-link>
            </template>
            <template v-else>
              <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
              <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
            </template>
          </div>
      </div>
    </div>
    <!--分隔线-->
    <div class="cght_topnavbox">
      <div class="cght_topnav cgw1216">
          <div class="cght_topnavlog">
              <router-link :to="{path:'/'}" target="_blank" title="志鹏供应链（内蒙古）有限公司">
                  <img src="../../assets/images/zp_666.jpg" height="60" alt="志鹏供应链（内蒙古）有限公司"/>
              </router-link>
          </div>
          <ul class="cght_topnavul">
            <li class="cght_topnavulxl cght_topnavulxz" @mouseenter="ShowHome()" @mouseleave="leaveHome()">
              <em>
                <router-link :to="{path:'/'}">首页<b></b></router-link>
                <!-- <div class="cght_topnavulxldiv" v-if="isShowHome">
                  <router-link :to="{path:'/MyOrder'}">我的订单</router-link>
                  <router-link :to="{path:'/Collect'}">商品收藏</router-link>
                  <router-link :to="{path:'/Historys'}">浏览历史</router-link>
                </div> -->
              </em>
            </li>
            <!-- <li class="cght_topnavulxl cght_topnavulxz" @mouseenter="ShowCate()" @mouseleave="leave()">
              <em>
                <a>账户设置<b></b></a>
                <div class="cght_topnavulxldiv" v-if="isShowCate">
                  <router-link :to="{path:'/PersonalData'}">个人资料</router-link>
                  <router-link :to="{path:'/Safety'}">安全设置</router-link>
                  <router-link :to="{path:'/Address'}">地址管理</router-link>
                </div>
              </em>
            </li> -->
            <!-- <li class="cght_topnavulxl cght_topnavulxz">
              <em>
                <router-link :to="{path:'/ExpenseAccount'}">采购明细<b></b></router-link>
              </em>
            </li>
            <li class="cght_topnavulxl cght_topnavulxz">
              <em>
                <router-link :to="{path:'/Finance'}">账单列表<b></b></router-link>
              </em>
            </li> -->
          </ul>
          <div class="cght_topnavright">
            <!-- <div class="cght_topnavrighta">
              <em><input type="text" keywords/></em><a href="javascript:;" search>搜索</a>
            </div> -->
            <div class="cght_topnavrightb">
              <router-link :to="{path:'/Cart'}" class="cght_topnavrightba">我的购物车<span></span></router-link>
                <!-- <template>
                  <a href="" class="cght_topnavrightbb">123</a>
                  <em style="position: absolute;left: 76px;top:1px;display: block;width: 6px;height: 6px;background: #cc0000;transform: rotate  (131deg);-moz-transform: rotate(131deg);-webkit-transform: rotate(131deg);"></em>
                </template> -->
            </div>
          </div>
      </div>
    </div>
    <div class="common-cover" v-if="isShow" @click="isShow=!isShow"></div>
    <div class="scxy_con">
      <div class="scxy_con_img close_btn_xy"></div>
      <div class="scxy_con_tit">
        《平台询价文件上传协议》
      </div>
      <div class="scxy_con_info">
        xxxx
      </div>
      <div class="scxy_con_btn">
        <a href="javascript:;" class="close_btn_xy" argee>同意</a>
      </div>
    </div>
    <div class="layout-right-bar">
      <div class="ehsy-sidebar">
          <div class="ehsy-sidebar-tabs">
              <div v-if="!current_user.id" class="side-item">
                  <div>
                      <router-link :to="{path:'/Login'}">
                          <i class="icon-right-bar el-icon-user"></i>
                          <p class="sidebar-item-des">登录</p>
                      </router-link>
                  </div>
              </div>
              <div v-else class="side-item">
                  <div>
                      <router-link :to="{path:'/MyOrder'}">
                          <i class="icon-right-bar el-icon-tickets"></i>
                          <p class="sidebar-item-des">订单</p>
                      </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div>
                      <router-link :to="{path:'/Cart'}">
                          <i class="icon-right-bar el-icon-shopping-cart-full"></i>
                          <p class="sidebar-item-des">购物车</p>
                      </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div>
                    <router-link :to="{path:'/Placeorder'}">
                      <i class="icon-right-bar el-icon-notebook-1"></i>
                      <p class="sidebar-item-des">帮助</p>
                    </router-link>
                  </div>
              </div>
              <div class="side-item">
                  <div>
                      <router-link :to="{path:'/Service'}">
                          <i class="icon-right-bar el-icon-service"></i>
                          <p class="sidebar-item-des">客服</p>
                      </router-link>
                  </div>
              </div>
              <div v-if="GoTopShow" class="side-item" style="margin-top:200px">
                  <div @click="toTop">
                    <i class="icon-right-bar el-icon-top"></i>
                    <p class="sidebar-item-des">顶部</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Top',
  data () {
    return {
      return_url: this.$route.fullPath,
      isShow: false,
      isShowCate: false,
      isShowHome: false,
      scroll: '', // 页面滚动的高度
      GoTopShow: false // 是否显示
    }
  },
  computed: {
    ...mapGetters([
      'current_user',
      'MassageCount'
    ])
  },
  watch: {
    scroll: function () {
      if (this.scroll > 500) {
        this.GoTopShow = true
      } else {
        this.GoTopShow = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
    if (this.current_user.id) {
      this.$store.dispatch('cart/getMassageCount')
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    ShowCate () {
      this.isShowCate = true
    },
    leave () {
      this.isShowCate = false
    },
    ShowHome () {
      this.isShowHome = true
    },
    leaveHome () {
      this.isShowHome = false
    },
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    },
    toTop () {
      this.toTopSpeed = setInterval(() => {
        document.documentElement.scrollTop = document.documentElement.scrollTop - 20
        // 通过改变数字实现动画延迟滚动
        if (this.scroll < 10) {
          clearInterval(this.toTopSpeed)
        }
      }, 1)
    }
  }
}
</script>
<style>
  @import '../../assets/css/cg_style.css';
  @import '../../assets/css/chongzhi.css';
  @import '../../assets/css/hxq_qyrz.css';
  /* 右侧导航 */
    .layout-right-bar {
        height: 100%;
        margin: 0;
        padding: 0;
        position: fixed;
        right: 0;
        top: 0;
        width: 0;
        z-index: 999;
    }
    .layout-right-bar .ehsy-sidebar {
        background-color: #5178b5;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        z-index: 999;
    }
    .layout-right-bar .ehsy-sidebar-tabs {
        margin-top: -76px;
        position: absolute;
        right: 0;
        top: 50%;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div {
        background-color: #5178b5;
        border-radius: 4px;
        height: 47px;
        margin-bottom: 2px;
        position: relative;
        width: 40px;
        border-radius: 4px 0px 0px 4px;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div:hover {
        background-color: #5c99f5;
    }
    .side-item {
        background: #fff;
        box-shadow: -2px 0 5px 0 rgb(43 43 62 / 6%);
        border-radius: 3px 0 0 3px;
        cursor: pointer;
    }
    .layout-right-bar .ehsy-sidebar-tabs > div div {
        height: 36px;
        left: 0;
        position: absolute;
        width: 36px;
    }
    .layout-right-bar .ehsy-sidebar i {
        display: block;
        margin: 6px auto;
        max-width: 24px;
        cursor: pointer;
    }
    .layout-right-bar .icon-rb-account {
        background-position: 0 0;
    }
    .layout-right-bar .icon-right-bar {
        color: #FFFFFF;
        height: 23px;
        width: 24px;
        font-size: 22px;
        padding-left: 6px;
    }
    .layout-right-bar .ehsy-sidebar .sidebar-item-des {
        width: 40px;
        height: 15px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 15px;
        margin-top: -5px;
        text-align: center;
    }
    /* 右侧导航 */
    .nav-icon-badge{
      font-size: 11px;
      padding: 0 5px;
      background-color: #f7261c;
      transform: translate(-50%,-40%);
      color: #fff;
      border-radius: 100px;
      position: relative;
      bottom: -3px;
      left: -9px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Member/Top.vue